import { render, staticRenderFns } from "./audit.vue?vue&type=template&id=3b2cd714&scoped=true&"
import script from "./audit.vue?vue&type=script&lang=js&"
export * from "./audit.vue?vue&type=script&lang=js&"
import style0 from "./audit.vue?vue&type=style&index=0&id=3b2cd714&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2cd714",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\CompanyProject\\HF-IM-electron-workbench\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b2cd714')) {
      api.createRecord('3b2cd714', component.options)
    } else {
      api.reload('3b2cd714', component.options)
    }
    module.hot.accept("./audit.vue?vue&type=template&id=3b2cd714&scoped=true&", function () {
      api.rerender('3b2cd714', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/detail/components/audit.vue"
export default component.exports